"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const LinkUI_vue_1 = __importDefault(require("../../../Common/LinkUI.vue"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const BaseMapConnector_1 = require("@becrop/components/Toolkit/Common/models/BaseMapConnector");
const BaseMap_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BaseMap.vue"));
const axios_1 = __importDefault(require("axios"));
const ModalStamp_vue_1 = __importDefault(require("../../../Common/ModalStamp.vue"));
const { ChevronLeft } = require('lucide-vue-next');
let MapView = class MapView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fsactivemap = false;
        this.cropColor = '';
        this.connector = new BaseMapConnector_1.BaseMapConnector(this.map_config);
        this.source = 'tracking';
        // MODAL
        this.typeModal = '';
        this.modalMapOpen = false;
        this.loader = false;
        this.msg = '';
        this.obj = {
            type: 'shp',
            file_name: this.fileName,
            gis_area_id: this.location.id,
            keep_parcels: false,
            source: this.source
        };
    }
    setView(value) {
        this.$emit('setView', value);
    }
    actionModalContinueSend() {
        this.setView('AreaSelection');
        this.$emit('setLocation', this.location);
    }
    actionModalCancelSend() {
        this.modalMapOpen = false;
    }
    backdropActionSend() {
        this.modalMapOpen = false;
    }
    mounted() {
        this.buildColor();
        this.connector.randomizeMarkerPosition(false);
        this.startActive();
    }
    buildColor() {
        const myDivObj = document.getElementById('hook_color');
        // @ts-ignore
        const myDivObjBgColor = window.getComputedStyle(myDivObj).backgroundColor;
        this.cropColor = myDivObjBgColor;
    }
    async onChangeActive() {
        await this.connector.draw();
        await (0, sleep_1.default)(300);
        // this.loading = false;
        await this.drawParcelsAndSamples();
    }
    async drawParcelsAndSamples() {
        this.connector.reset();
        this.poligonos.forEach((polygon) => {
            this.connector.drawPolygon({
                color: this.cropColor,
                shape: polygon,
            });
        });
        this.connector.center();
    }
    async startActive() {
        await (0, sleep_1.default)(100);
        await this.onChangeActive();
    }
    async completedRate() {
        // TODO: ENDPOINT PARA GUARDAR COMO PARCELAS!!
        try {
            this.loader = true;
            const data = await axios_1.default.post('/tracking/saveloaded', this.obj);
            const res = await data;
            console.log(res);
            this.modalMapOpen = true;
            this.typeModal = 'success';
            this.msg = res.data.msg;
            this.loader = false;
        }
        catch (error) {
            this.loader = true;
            console.log(error);
            this.modalMapOpen = true;
            this.typeModal = 'error';
            this.msg = error.message;
            this.loader = false;
            /* this.openModal('error', []); */
        }
    }
    onFullscreenChange(fullscreen) {
        this.fsactivemap = fullscreen;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MapView.prototype, "location", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MapView.prototype, "fileName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MapView.prototype, "poligonos", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line camelcase
], MapView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('active')
], MapView.prototype, "onChangeActive", null);
MapView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            LinkUI: LinkUI_vue_1.default,
            ChevronLeft,
            BaseMap: BaseMap_vue_1.default,
            ModalStamp: ModalStamp_vue_1.default,
        },
    })
], MapView);
exports.default = MapView;
